<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :height="size"
    viewBox="0 0 40 40"
    opacity="1"
    :style="{ 'margin-top': top + 'px', 'margin-left': left + 'px' }"
  >
    <g transform="translate(8 8)" :stroke="color" stroke-width="2.5">
      <circle cx="10" cy="10" r="9.25" fill="none" />
    </g>
    <line
      x2="6"
      y2="6"
      transform="translate(24.5 24.5)"
      :stroke="color"
      stroke-linecap="round"
      stroke-width="2.5"
    />
  </svg>
</template>

<script>
export default {
  props: {
    size: { type: [Number, String], default: 32 },
    color: { type: String, default: "#000" },
    top: { type: [Number, String], default: 3 },
    left: { type: [Number, String], default: 3 },
  },
};
</script>

<style scoped>
svg {
}
</style>
